import { Injectable, inject } from '@angular/core';
import {
  UnprocessableEntityErrorCode,
  UnprocessableEntityErrorMessageParameter,
  UnprocessableEntityErrorMessageProviderService,
} from '@web/core';
import { isNil, Nillable, valueOrDefault } from '@web/utils';
import { UnprocessableEntityHttpErrorResponse } from '@web/common';
import { PublicCartAttributeName } from '@web/shared/module/shop';
import { PublicCheckoutApiFieldsMapping } from '../../types/public-checkout-api-fields-mapping';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PublicCheckoutHttpErrorHandler {
  /* prettier-ignore */
  private readonly provider = inject(UnprocessableEntityErrorMessageProviderService);

  public extract(options: {
    response: HttpErrorResponse;
    mappings: Map<string, PublicCheckoutApiFieldsMapping>;
  }): Nillable<string[]> {
    const { response, mappings } = options;

    const labels = new Map<PublicCartAttributeName, string>(
      [...mappings.entries()].map(([_, value]) => [
        value.apiPath,
        value.violationPropertyPathLabel,
      ]),
    );

    /* prettier-ignore */
    return UnprocessableEntityHttpErrorResponse.fromResponse<UnprocessableEntityErrorCode, UnprocessableEntityErrorMessageParameter>(response).violations.map((violation) => {
      const label = valueOrDefault(labels.get(violation.propertyPath as PublicCartAttributeName), null);
      const code = violation.code;
      const params = violation.parameters;

      try {
        if (!isNil(label)) {
          return `Wystąpił błąd w polu "${label}". ${this.provider.message(code, params)}`;
        }

        return `${this.provider.message(code, params)}`
      } catch (e) {
        if (!isNil(label)) {
          return `Wystąpił błąd w polu "${label}". Nieznany kod błędu "${code}".`;
        }

        return `Nieznany kod błędu "${code}".`;
      }
    });
  }
}
